<table datatable class="table align-middle effects-table">
    <thead *ngIf="showHeader">
        <tr class="default-behavior-header">
            <th>
                {{"Default behavior" | translate}}
            </th>
            <th>
                <toggle-buttons
                    [size]="'xs'"
                    [labelTrue]="'Activate'"
                    [labelFalse]="'Deactivate'"
                    [value]="getDefaultProperty('activate', true)"
                    (changed)="updateComponent($event, 'activate')"></toggle-buttons>
                <toggle-buttons class="ml-2" *ngIf="getDefaultProperty('activate', true)"
                    [size]="'xs'"
                    [labelTrue]="'Show'"
                    [labelFalse]="'Hide'"
                    [value]="getDefaultProperty('hidden', false)"
                    [reverse]=true
                    (changed)="updateComponent($event, 'hidden')"></toggle-buttons>
                <toggle-buttons class="ml-2" *ngIf="getDefaultProperty('activate', true) && !getDefaultProperty('hidden', false)"
                    [size]="'xs'"
                    [labelTrue]="'Enable'"
                    [labelFalse]="'Disable'"
                    [value]="getDefaultProperty('disabled', false)"
                    [reverse]=true
                    (changed)="updateComponent($event, 'disabled')"></toggle-buttons>
            </th>
            <th></th>
        </tr>
        <tr *ngIf="effects?.length" class="separator-header"><th colspan="3"></th></tr>
        <tr *ngIf="effects?.length" class="separator-header"><th colspan="3"></th></tr>
        <tr *ngIf="effects?.length" class="separator-header"><th colspan="3"></th></tr>
        <tr *ngIf="effects?.length" class="column-header">
            <th>{{'Determinant' | translate}}</th>
            <th>{{'Effect' | translate}}</th>
            <th class="text-center cell-delete">&nbsp;</th>
        </tr>
        <tr class="separator-header"><th colspan="3"></th></tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let effect of effects; let i=index;">
            <tr *ngIf="isDeterminantEmpty(effect.jsonDeterminants)" class="separator-row"><td colspan="3"></td></tr>
            <tr id="{{effect.id}}">
                <td (click)="openBuilder(effect)">
                    <warning-tooltip *ngIf="checkDuplicateEffects(effect)"
                        class="effect-warning"
                        [type]="'warning'"
                        [text]="'Effects are the same for several determinants.'">
                    </warning-tooltip>
                    <warning-tooltip *ngIf="checkDefaults(effect) && !checkUnsetDet()"
                        class="effect-warning"
                        [text]="'Actions are the same as Defaults ones. This row will have no effects.'">
                    </warning-tooltip>
                    <warning-tooltip *ngIf="checkDuplicateDets(effect)"
                        class="effect-warning"
                        [text]="'Same determinant is used several times.'">
                    </warning-tooltip>
                    <determinant-query-readonly *ngIf="!isDeterminantEmpty(effect.jsonDeterminants)"
                        [jsonDeterminants]="effect.jsonDeterminants"
                        [hasError]="checkDuplicateDets(effect)"
                        [determinantMapById]="determinantMapById"></determinant-query-readonly>
                    <div class="workarea__draghere" *ngIf="isDeterminantEmpty(effect.jsonDeterminants)">
                        <div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
                    </div>
                </td>
                <td>
                    <span class="px-2 py-1 alert alert-warning alert-warning-small" *ngIf="isDeterminantEmpty(effect.jsonDeterminants)">
                        <i class="fad fa-info-circle mr-2"></i>{{ "Please select a determinant" | translate }}
                    </span>
                    <toggle-buttons *ngIf="!isDeterminantEmpty(effect.jsonDeterminants)"
                        class="d-block"
                        [size]="'xs'"
                        [labelTrue]="'Activate'"
                        [hasError]="(checkDefaults(effect) && !checkUnsetDet())"
                        [hasWarning]="checkDuplicateEffects(effect)"
                        [labelFalse]="'Deactivate'"
                        [value]="getPropertyValue(effect, 'activate', true)"
                        (changed)="updateEffectProperty($event, 'activate', effect)"></toggle-buttons>
                    <toggle-buttons class="d-block" *ngIf="!isDeterminantEmpty(effect.jsonDeterminants) && getPropertyValue(effect, 'activate', true)"
                        [size]="'xs'"
                        [labelTrue]="'Show'"
                        [labelFalse]="'Hide'"
                        [hasError]="(checkDefaults(effect) && !checkUnsetDet())"
                        [hasWarning]="checkDuplicateEffects(effect)"
                        [value]="getPropertyValue(effect, 'show', true)"
                        (changed)="updateEffectProperty($event, 'show', effect)"></toggle-buttons>
                    <toggle-buttons class="d-block" *ngIf="!isDeterminantEmpty(effect.jsonDeterminants) && getPropertyValue(effect, 'activate', true) && getPropertyValue(effect, 'show', true)"
                        [size]="'xs'"
                        [labelTrue]="'Enable'"
                        [labelFalse]="'Disable'"
                        [value]="getPropertyValue(effect, 'disabled', false)"
                        [hasError]="(checkDefaults(effect) && !checkUnsetDet())"
                        [hasWarning]="checkDuplicateEffects(effect)"
                        [reverse]=true
                        (changed)="updateEffectProperty($event, 'disabled', effect)"></toggle-buttons>
                </td>
                <td class="cell-delete"><i (click)="deleteEffect(i)" class="btn-xs btn-bordered btn-danger btn-icon fas fa-times"></i></td>
            </tr>
        </ng-container>
        <tr class="separator-row" *ngIf="effects?.length"><td colspan="3"></td></tr>
        <tr class="placeholder-row" (click)="createEffectAndOpenBuilder()">
            <td>
                <div class="workarea__draghere">
                    <div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
                </div>
            </td>
            <td>
                <span class="px-2 py-1 alert alert-warning alert-warning-small">
                    <i class="fad fa-info-circle mr-2"></i>{{ "Please select a determinant" | translate }}
                </span>
            </td>
            <td></td>
        </tr>
    </tbody>
</table>

<drawer [title]="'Manage determinants'"
    [showHeader]="showDrawerHeader"
    [isClosed]="isManageDetsClosed"
    (saveEvent)="updateDeterminant($event)"
    [embedded]=true
    [contextLabel]="componentName"
    (closeEvent)="closeBuilder();"
    class="text-left in-modal-drawer">
    <div class="drawer-content drawer-direct-content">
        <determinant-manager
            *ngIf="serviceId && tempEffect"
            [serviceId]="serviceId"
            [determinantMapById]="determinantMapById"
            [jsonString]="tempEffect.jsonDeterminants"
            (builderUpdated)="temoupdateDeterminant($event)"
            [showBuilder]=true
            (cancel)="closeBuilder()"
            (updateHeader)="showModalHeader($event)"
            class="d-flex overflow-hidden mh-100 h-100 w-100">
        </determinant-manager>
    </div>
</drawer>